import * as React from 'react'
import './CustomMetricError.css'
import IconPanel from '@mulesoft/anypoint-icons/lib/Icon'

export type ValueProps = {
  show: boolean
}

export type Props = ValueProps

export const CustomMetricError = (props: Props) => {
  const baseClassName = 'custom-metric-error'
  const className = props.show ? `${baseClassName} custom-metric-error-show` : baseClassName

  return (
    <div className={className}>
      <IconPanel
        testId={'custom-metric-error-icon'}
        className="custom-metric-error-icon"
        name={'warning-small'}
        size={14}
        fill={'rgba(0, 162, 223, 0.85)'}
      />
      <div className="custom-metric-error-message">
        <span>Select a measurement for this chart</span>
      </div>
    </div>
  )
}